export default function ChatImage() {
  return (
    <img
      width={367}
      height={562}
      alt="Earth's Core"
      src={`/compatibility-snippets/chat.png`}
    />
  );
}
